<template>
    <div id="app" ref="App">
        <div class="hrh" v-if="showHRH">
            <div class="hrh-wrapper">
                <div class="logo">
                    <img :src="`${$store.state.clientConfig.directoryUrl}/img/logo.png`" :alt="$store.state.clientConfig.schemeName" />
                </div>
                <div class="message">
                    <p class="title">{{ $store.state.clientConfig.showHRH.title }}</p>
                    <p class="text">{{ $store.state.clientConfig.showHRH.text }}</p>

                </div>
                <button @click="hideHRS = true;" class="continue-to-site button-outline-rounded">
                    Continue to the member website
                </button>
            </div>
        </div>
        <mfaWordingModal v-if="enableMFAWording" />
        <dynamicConfigModal v-else-if="isRoot" />
        <login-register-modal />
        <transition name="fade" mode="out-in">
            <div v-if="$store.state.ui.dataLoaded">
                <top-header v-if="!hideNav" :formSite="formSite" :modellerOnly="modellerOnlySite" />
                <pageLoader v-show="$store.state.ui.loader.show" :themeColour="$store.state.clientConfig.colours.primary"
                    :loadingText="$store.state.ui.loader.message" />
                <transition name="fade" mode="out-in">
                    <router-view class="router-view" />
                </transition>

                <defaultFooter :class="{ footerMobile: isModeller }" />
                <transition name="fade" mode="out-in">
                    <enquiriesModal v-if="showEnquriesModal" />
                    <loginRegisterModal v-if="showLoginRegisterModal" />
                </transition>
            </div>
        </transition>
    </div>
</template>
<script>
import cssVars from 'css-vars-ponyfill';
import axios from 'axios';
import topHeader from '@/components/layout/mainHeader.vue';
import defaultFooter from '@/components/layout/Footer.vue';
import enquiriesModal from '@/components/layout/enquiriesModal.vue';
import loginRegisterModal from '@/components/loginRegisterModal.vue';
import pageLoader from '@/components/layout/pageLoader.vue';
import dynamicConfigModal from '@/components/layout/dynamicConfigModal.vue';
import auth from '@/services/authentication';
import { mapGetters } from 'vuex';
import mfaWordingModal from '@/components/layout/mfaWordingModal.vue';

export default {
    name: 'App',
    components: {
        topHeader,
        defaultFooter,
        enquiriesModal,
        pageLoader,
        loginRegisterModal,
        mfaWordingModal,
        dynamicConfigModal,
    },
    data () {
        return {
            schemeConfig: {},
            hideHRS: false,
        };
    },

    metaInfo () {
        return {
            title: this.schemeConfig.schemeName,
            meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: `This website provides you with information about your benefits in the defined benefit section of the ${this.schemeConfig.fundOrScheme}. It also allows you to update your details and find other helpful resources around ${this.formatTheSchemeName} `,
                },
            ],
        };
    },
    created () {
        // lets get the config
        const qString = this.$moment().format('DDMMYYYYHH');
        let directory = '';
        if (process.env.NODE_ENV === 'production') {
            directory = `https://teslawebclientconfig.blob.core.windows.net/sites/${window.location.hostname}`;
        } else {
            // directory = 'https://teslawebclientconfig.blob.core.windows.net/sites/icipensionfundqa.lcptest.co.uk';
            // directory = 'https://teslawebclientconfig.blob.core.windows.net/sites/northernfoodspensionscheme.lcp.uk.com';
            directory = 'https://teslawebclientconfig.blob.core.windows.net/sites/memberwebdev.lcptest.co.uk';
            // directory = 'https://teslawebclientconfig.blob.core.windows.net/sites/lowandbonarschemeqa.lcptest.co.uk';
            // directory = 'https://teslawebclientconfig.blob.core.windows.net/sites/eefstaffpensionfund.lcptest.co.uk';
            // directory = 'https://teslawebclientconfig.blob.core.windows.net/sites/novunapensionschemeqa.lcptest.co.uk';
            // directory = 'https://teslawebclientconfig.blob.core.windows.net/sites/nmrpensionfund.lcptest.co.uk';
            // directory = 'https://teslawebclientconfig.blob.core.windows.net/sites/nmrpensionfund.lcp.uk.com';
            // directory = 'https://teslawebclientconfig.blob.core.windows.net/sites/dtzqa.lcptest.co.uk';
            // directory = '';
        }

        const config = `${directory}/config.json?q=${qString}`;
        axios
            .get(config, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then((blobConfig) => {
                const schemeConfig = blobConfig.data;
                schemeConfig.directoryUrl = directory;
                this.schemeConfig = schemeConfig;
                this.$store.dispatch('clientConfig/setClientConfig', schemeConfig);
                // now lets set the page title
                cssVars({
                    variables: {
                        '--primaryColour': schemeConfig.colours.primary,
                        '--secondaryColour': schemeConfig.colours.secondary,
                        '--textOnPrimary': schemeConfig.colours.textOnPrimary,
                        '--textOnSecondary': schemeConfig.colours.textOnSecondary,
                        '--buttonDefault': schemeConfig.colours.buttonDefault || schemeConfig.colours.primary,
                        '--buttonDefaultText': schemeConfig.colours.buttonDefaultText || '#FFFFFF',
                        '--greyColour': schemeConfig.colours.grey,
                        '--navFont': schemeConfig.colours.navFont !== undefined ? schemeConfig.colours.navFont : '#ffffff',
                        '--iconFont': schemeConfig.colours.iconFont !== undefined ? schemeConfig.colours.iconFont : schemeConfig.colours.primary,
                        '--navColour': schemeConfig.colours.navBackground !== undefined ? schemeConfig.colours.navBackground : schemeConfig.colours.primary,
                        '--homepageFooter':
                            schemeConfig.homepage !== undefined && schemeConfig.homepage.footer !== null
                                ? schemeConfig.homepage.footer
                                : 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDBweCIgdmlld0JveD0iMCAwIDEyODAgMTQwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGw9IiNmZmZmZmYiPjxwYXRoIGQ9Ik0xMDk0LjQ0IDExOUwxNzIuNyA2OC43MmE3NC41NCA3NC41NCAwIDAgMS0yNS4xOS01Ljk1TDAgMHYxNDBoMTI4MFYwbC0xMzMuODUgMTAyYy0xNS44NCAxMi4wOS0zMy43IDE3Ljk1LTUxLjcxIDE3eiIgZmlsbC1vcGFjaXR5PSIuNSIvPjxwYXRoIGQ9Ik0xMDkzLjQ4IDEzMS44NUwxNzMgOTRhNzYuODUgNzYuODUgMCAwIDEtMzYuNzktMTEuNDZMMCAwdjE0MGgxMjgwVjBsLTEzMS44MSAxMTEuNjhjLTE2LjQ3IDEzLjk2LTM1LjQ3IDIwLjk2LTU0LjcxIDIwLjE3eiIvPjwvZz48L3N2Zz4=")',
                    },
                    watch: true,
                });
                const publicCode = process.env.VUE_APP_PUBLICAPICODE;
                const publicApiUrl = process.env.VUE_APP_APIADDRESSPUBLIC;
                axios
                    .get(`${publicApiUrl}/GetConfiguration?code=${publicCode}`, {
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                    .then((adminConfig) => {
                        this.schemeConfig = !this.schemeConfig.formSite ? { ...this.schemeConfig, ...adminConfig.data } : this.schemeConfig;
                        this.$store.dispatch('clientConfig/setClientConfig', this.schemeConfig);
                        this.$store.dispatch('helpTopics/initialiseFaqs', this.schemeConfig);
                        auth.init();
                        this.$store.commit('setDataLoaded', true);
                    });
            });
        window.addEventListener('resize', this.debounce(this.resizeHandler, 150, false));
        this.resizeHandler();
    },
    mounted () {
        this.$store.dispatch('auth/checkIfLoggedIn').then((isLoggedIn) => {
            if (isLoggedIn) {
                this.$store.dispatch('auth/checkIfRegistered', false);
            }
        });
        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/png';
        link.rel = 'icon';
        link.href = `https://teslawebclientconfig.blob.core.windows.net/sites/${window.location.hostname}/img/favicon.png`;
        document.getElementsByTagName('head')[0].appendChild(link);
        this.height = window.innerHeight;
    },

    methods: {
        resizeHandler () {
            // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
            const vh = window.innerHeight * 0.01;
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            document.documentElement.style.setProperty('--vh100', `${vh * 100}px`);
        },
        debounce (func, wait, immediate) {
            let timeout;
            return () => {
                const context = this; const
                    // eslint-disable-next-line prefer-rest-params
                    args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                }, wait);
                if (immediate && !timeout) func.apply(context, args);
            };
        },
    },
    computed: {
        ...mapGetters('clientConfig', [
            'formatTheSchemeName',
        ]),
        enableMFAWording () {
            return this.$store.state.clientConfig.enableMFAWording && this.isRoot;
        },

        isRoot () {
            return this.$route.name === 'home';
        },
        isModeller () {
            return this.$route.name === 'pension-tool';
        },
        showEnquriesModal () {
            return this.$store.state.ui.showEnquriesModal;
        },
        showLoginRegisterModal () {
            return this.$store.state.ui.showLoginRegisterModal;
        },
        hideNav () {
            return this.$route.meta.hideNav;
        },
        currentUrl () {
            return window.location.hostname;
        },
        formSite () {
            return this.$store.state.clientConfig.formSite || false;
        },
        modellerOnlySite () {
            return this.$store.state.clientConfig.modellerOnly || false;
        },
        isIdle () {
            return this.isAppIdle;
        },
        loggedIn () {
            return this.$store.getters['auth/getAuthState'];
        },
        showHRH () {
            return this.$store.state.clientConfig.showHRH && this.hideHRS === false;
        },
    },
    watch: {
        isIdle () {
            if (this.isIdle && !this.formSite) {
                if (this.loggedIn) {
                    this.$router.push('/logout');
                }
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/assets/scss/_base.scss';

::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    background-color: #f5f5f5;
}

::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
    background-color: var(--primaryColour);
}

.fade-enter-active,
.fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}

body {
    overflow: hidden;
    font-family: 'Montserrat', Helvetica, Arial, sans-serif;
}

html {
    font-size: 16px;
}

#app {
    min-height: 100vh;
    /* Fallback for browsers that do not support Custom Properties */
    min-height: calc(var(--vh, 1vh) * 100);
    position: relative;
    overflow: hidden;
}

.hrh {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: black;
    z-index: 20;

    .hrh-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        ;

        .logo {
            margin-bottom: 40px;

            img {
                max-width: 300px;

            }
        }

        .message {
            color: white;

            margin-bottom: 40px;

            .title {
                font-size: 36px;
            }

            .text {
                font-size: 26px;
            }

            @include responsive("sm") {
                .title {
                    font-size: 22px;
                }

                .text {
                    font-size: 18px;
                }
            }
        }
    }
}
</style>
